export interface PasswordContract {
  algorithm: string;
  hash: string;
  iterations: number;
  salt: string;
}
